// GENERATED by scripts/sync-tokens.mjs from MafiaGo/Assets/_Project/UI/Styles/SocTheme.uss. Do not edit.
// The same table as tokens.css, for code that cannot resolve a var().

export const SOC = {
  'bg': 'rgb(14, 12, 10)',
  'bg-deep': 'rgb(5, 4, 3)',
  'panel': 'rgb(26, 23, 20)',
  'panel-raised': 'rgb(37, 32, 23)',
  'panel-light': 'rgb(46, 40, 32)',
  'ink': 'rgb(232, 227, 214)',
  'ink-soft': 'rgb(181, 173, 154)',
  'ink-mute': 'rgb(106, 96, 80)',
  'ink-fade': 'rgb(58, 51, 39)',
  'outline': 'rgb(10, 8, 7)',
  'border': 'rgb(42, 37, 32)',
  'border-light': 'rgb(58, 51, 39)',
  'crimson': 'rgb(193, 18, 31)',
  'crimson-dim': 'rgb(139, 13, 23)',
  'crimson-bright': 'rgb(212, 32, 48)',
  'crimson-ridge': 'rgb(255, 64, 80)',
  'crimson-wash': 'rgba(193, 18, 31, 0.08)',
  'crimson-glow': 'rgba(193, 18, 31, 0.30)',
  'plate': 'rgb(145, 139, 125)',
  'plate-ink': 'rgb(26, 20, 16)',
  'chrome': 'rgb(201, 194, 178)',
  'chrome-dark': 'rgb(106, 101, 91)',
  'brass': 'rgb(184, 138, 58)',
  'brass-dim': 'rgb(138, 104, 40)',
  'fog': 'rgba(200, 190, 170, 0.08)',
  'rain': 'rgba(180, 200, 220, 0.10)',
  'scrim': 'rgba(10, 8, 7, 0.85)',
  'neon-warm': 'rgb(255, 90, 60)',
  'neon-cold': 'rgb(74, 140, 184)',
  'money': 'rgb(106, 138, 74)',
  'success': 'rgb(122, 150, 85)',
  'warning': 'rgb(192, 138, 58)',
  'danger': 'rgb(193, 18, 31)',
  'info': 'rgb(74, 140, 184)',
  'currency-dirty': 'rgb(184, 138, 58)',
  'currency-clean': 'rgb(106, 138, 74)',
  'currency-influence': 'rgb(201, 194, 178)',
  'fx-italian': 'rgb(138, 154, 85)',
  'fx-yakuza': 'rgb(184, 48, 48)',
  'fx-cartel': 'rgb(184, 138, 58)',
  'fx-triad': 'rgb(74, 122, 154)',
  'fx-neutral': 'rgb(106, 96, 80)',
  'space-1': '4px',
  'space-2': '8px',
  'space-3': '12px',
  'space-4': '16px',
  'space-5': '24px',
  'space-6': '32px',
  'gutter': '16px',
  'card-gap': '8px',
  'card-pad': '13px',
  'radius-0': '0',
  'radius-sm': '2px',
  'radius-md': '3px',
  'radius-lg': '4px',
  'tap-min': '44px',
  'btn-height': '46px',
  'btn-height-sm': '44px',
  'meter-height': '7px',
  'stripe-width': '3px',
  'header-pad-top': '36px',
  'header-pad-sheet': '12px',
} as const

export type SocToken = keyof typeof SOC
